import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function ExcellenceView() {
  useDocumentTitle('Quality and clinical excellence-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-6'}
        title={'Quality and Clinical Excellence'}
        link={'Quality and Clinical Excellence'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Combining skills, expertise, and knowledge to offer quality care
                services
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">O</span>ur goal has always
                  been to provide a specialist home healthcare service to those
                  with life-limiting conditions and complex needs.
                </p>
                <p className="values_p3">
                  We are therefore committed to providing excellent care with
                  the skills, expertise, and knowledge of our team in order to
                  offer the best standards of person-centered care at home.
                </p>
                <p className="values_p3">
                  We have a vibrant governance and policy framework that ensures
                  that our nurse-led care is safely provided, not just to high
                  standards but also in compliance with regulations. Through
                  these high standards, we are able to keep track of our care
                  services. We can also respond quickly and effectively to
                  guidance and feedback, ensuring that we continue to put our
                  clients and our standards of service for them at the center of
                  all we do.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Providing excellent care and services
                </h2>
                <p className="white-color">
                  We are sure that quality and clinical excellence are critical
                  to ensuring that we give excellent care to our clients.
                  Therefore we are committed to:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Employing qualified, skilled, experienced, and
                      compassionate healthcare professionals, including
                      registered nurses, healthcare assistants, nursery nurses,
                      and clinical nurse specialists.
                    </li>
                    <li className="">
                      Making sure that our healthcare professionals receive
                      continuous training and development so that they are not
                      only up to date with the most recent requirements and
                      regulations according to national standards, but are also
                      trained in the complex and individualized care needs of
                      their clients.
                    </li>
                    <li>
                      Fostering relationships that are open and honest as well
                      as asking for feedback from our employees, stakeholders,
                      and clients.
                    </li>
                    <li>
                      Constantly searching out and sharing best practices,
                      innovation, and quality development.
                    </li>
                    <li>
                      {' '}
                      Regularly reviewing, evolving, and improving our services.
                    </li>
                    <li>
                      Regularly reviewing our healthcare staff, procedures, and
                      policies.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Our regulators</h2>
                <p className="">
                  The Care Quality Commission (CQC) oversees and audits all
                  healthcare service companies. To guarantee the safe and
                  efficient provision of healthcare services, we maintain a
                  close working relationship with our regulator.
                </p>
                <p>
                  To ensure that every element of our service and the personnel
                  of Quality Health and Homecare Services are completely
                  compliant, we continually review our procedures.
                </p>
                <p>
                  Visit our locations to examine ratings for each of our
                  regional offices, or look at our ratings on the Care Quality
                  Commission website.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Working in partnership</h2>
                <p className="white-color">
                  We regularly communicate with and report to Integrated Care
                  Boards (ICBs), Local Authorities, and Case Managers, where we
                  work through monthly reports, review sessions, and, when
                  necessary, joint meetings with our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Safeguarding</h2>
                <p className="">
                  At Quality Health and Home Care Services, safeguarding is a
                  crucial component of every job to show that everyone has a
                  duty to protect our clients and employees from harm and
                  mistreatment.
                </p>
                <p>
                  By fostering an atmosphere where employees feel free to voice
                  concerns and are supported in upholding their safeguarding
                  obligations, we ensure that every member of our staff is
                  qualified to carry out their duties for promoting and
                  safeguarding the welfare of children and
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Safeguarding Training</h2>
                <p className="white-color">
                  All employees are required to receive safeguarding training up
                  to Safeguarding Level 3 e-learning and Safeguarding Children
                  and Young People. Regardless of whether staff only work with
                  adults, training is provided to educate them on any adult
                  issues that affect children's well-being, including mental
                  illness in parents or caregivers, domestic violence, and drug
                  or alcohol abuse. It also offers advice on adults who might be
                  a danger to children for other reasons, such as "Hidden Harm."
                  The Quality Health and Home Care Services safeguarding policy
                  and incident reporting procedure are covered in detail in this
                  training, which is given at company induction and must be
                  repeated every three years.
                </p>
                <p className="white-color"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default ExcellenceView;
